export const GQLErrorCodes = {
  SSN_MINOR: 'SSN_MINOR',
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
}
